const sensitiveFields = new Set([
    "firstname",
    "lastname",
    "username",
    "email",
    "phonenumber",
    "phone",
    "password",
    "saltypasswordhash",
    "dateofbirth",
    "dob",
    "birthdate",
    "token",
    "accesstoken",
    "refreshtoken",
    "givenname",
    "familyname",
    "middlename",
    "preferredname",
    "nickname",
    "primaryphone",
    "name",
    "teamworksname",
    "teamworksusername",
    "knownas",
    "to",
    "orgname",
    "address",
    "streetaddress",
]);
const EMAIL_REGEX = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
const PHONE_REGEX = /\b\+?[\d][\d\s.\-()]{6,18}[\d]\b/g;
function sanitizeString(str) {
    return str.replace(EMAIL_REGEX, "***").replace(PHONE_REGEX, "***");
}
function maskFields(obj, seen = new WeakSet()) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    if (typeof obj === "string") {
        return sanitizeString(obj);
    }
    if (typeof obj === "object") {
        if (seen.has(obj)) {
            return "[Circular]";
        }
        seen.add(obj);
        if (Array.isArray(obj)) {
            return obj.map(item => maskFields(item, seen));
        }
        const masked = {};
        for (const [key, value] of Object.entries(obj)) {
            if (sensitiveFields.has(key.toLowerCase())) {
                if (value === null) {
                    masked[key] = "NULL";
                }
                else if (value === "" || (typeof value === "object" && Object.keys(value).length === 0)) {
                    masked[key] = "EMPTY";
                }
                else {
                    masked[key] = "***";
                }
            }
            else {
                masked[key] = maskFields(value, seen);
            }
        }
        return masked;
    }
    return obj;
}
export const obfuscateSensitiveData = (obj) => {
    return maskFields(obj);
};
//# sourceMappingURL=sensitiveDataObfuscator.js.map